<div
    [@guizmoAnimation]="guizmoAnimationState"
    [@strapAnimation]="strapAnimationState"
    (@guizmoAnimation.done)="animationDone($event, 'guizmo')"
    (@strapAnimation.done)="animationDone($event, 'strap')"
    class="apw-animations-container">
    @if (currentStrapSku) {
    <picture>
        <source [attr.media]="'all'" [attr.srcset]="getImageUrl(currentStrapSku, size)" />
        <img [attr.src]="getImageUrl(currentStrapSku, size)" alt="" class="strap currentStrap" />
    </picture>
    } @if (nextStrapSku) {
    <picture>
        <source [attr.media]="'all'" [attr.srcset]="getImageUrl(nextStrapSku, size)" />
        <img [attr.src]="getImageUrl(nextStrapSku, size)" alt="" class="strap nextStrap" />
    </picture>
    } @if (currentGuizmoSku) {
    <picture>
        <source [attr.media]="'all'" [attr.srcset]="getImageUrl(currentGuizmoSku, size)" />
        <img [attr.src]="getImageUrl(currentGuizmoSku, size)" alt="" class="guizmo currentGuizmo" />
    </picture>
    } @if (nextGuizmoSku) {
    <picture>
        <source [attr.media]="'all'" [attr.srcset]="getImageUrl(nextGuizmoSku, size)" />
        <img [attr.src]="getImageUrl(nextGuizmoSku, size)" alt="" class="guizmo nextGuizmo" />
    </picture>
    }
</div>
